var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"content__buttons-row",attrs:{"type":"flex","justify":"end"}},[_c('el-col',{attrs:{"span":24}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }